// extracted by mini-css-extract-plugin
export var scrollArea = "_ns-0";